module.exports = __webpack_public_path__ + "img/315.3c104090.jpg";